<!--
Author:
Description: 房产客户关系参照框
-->
<template>
  <div>
    <el-dialog
      :title="title"
      class="com-housecustdefend-ref"
      :before-close="handleCancel"
      :close-on-click-modal="false"
      v-dialogDrag
      :show-close="false"
      :append-to-body="true"
      :modal="true"
      width="540px"
      v-bind="{ ...$props, ...$attrs }"
      style="margin-top: 100px"
    >
      <el-form
        :inline="true"
        :model="form"
        label-width="140px"
        ref="form"
        :rules="rules"
        size="mini"
        style="margin-top: -10px"
        label-suffix=":"
      >
        <el-col style="height: 36px" hidden>
          <el-form-item label="房产" prop="houseId">
            <el-input v-model="form.houseId" :disabled="isEditDisabled"></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="this.title != '车位关联'" style="height: 36px">
          <el-form-item :label="nameone" prop="populId">
            <populregisterSelect
              :multiple="true"
              v-show="!isEditDisabled"
              :custByorgId="houseCustDefedcustByorgId"
              v-model="form.populId"
              :label.sync="form.populName"
              @change="(id, obj) => handlePopulChange(id, obj)"
              :disabled="isReRent"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="this.title === '车位关联'" style="height: 36px">
          <el-form-item :label="nameone" prop="houseId">
            <proRoomRegisterSelect
              :multiple="false"
              :isHouse="true"
              v-show="!isEditDisabled"
              :custByorgId="houseCustDefedcustByorgId"
              v-model="form.linkedHouseId"
              :label.sync="form.linkedHouseName"
              @change="(id, obj) => handleHouseChange(id, obj)"
              :disabled="false"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="this.title != '车位关联'" style="height: 36px">
          <el-form-item label="是否业主" prop="isOwner">
            <el-select
              v-model="form.isOwner"
              style="width: 100%"
              clearable
              placeholder="请选择"
              :disabled="isEditDisabled || isReRent || isOwnerStatus"
            >
              <el-option
                v-for="item in yesOrNoOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.status === 0"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="title != '业主登记' && title != '房产过户' && title != '车位关联'"
          style="height: 36px"
        >
          <el-form-item label="签约日期" prop="signDate">
            <el-date-picker
              v-model="form.signDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="title == '退租' || title == '续租'"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="title == '退租'" style="height: 36px">
          <el-form-item label="退租日期" prop="endRentTime">
            <el-date-picker
              v-model="form.endRentTime"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="title == '车位关联'" style="height: 36px">
          <el-form-item label="收费标准" prop="proCostnormId">
            <el-input
              v-model="form.proCostnormName"
              :disabled="isproCostnormEditDisabled || isReRent"
              @click.native="partiesClick"
              clearable
              @change="changeproCostnormId(form.proCostnormName)"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="title != '房产过户' && title != '退租'" style="height: 36px">
          <el-form-item label="是否历史" prop="isHistory">
            <el-select
              v-model="form.isHistory"
              style="width: 100%"
              clearable
              placeholder="请选择"
              :disabled="true"
            >
              <el-option
                v-for="item in yesOrNoOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.status === 0"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            title != '房产过户' &&
            title != '续租' &&
            title != '租赁' &&
            title != '退租' &&
            title != '车位关联'
          "
          style="height: 36px"
        >
          <el-form-item label="入住日期" prop="checkInDate">
            <el-date-picker
              @change="checkdate(form.checkInDate)"
              v-model="form.checkInDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="title != '业主登记' && title != '房产过户'" style="height: 36px">
          <el-form-item label="租赁开始日期" prop="startLeaseDate">
            <el-date-picker
              v-model="form.startLeaseDate"
              type="date"
              @change="changestart"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled || isReRent"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="title != '业主登记' && title != '房产过户'" style="height: 36px">
          <el-form-item label="租赁结束日期" prop="endLeaseDate">
            <el-date-picker
              v-model="form.endLeaseDate"
              type="date"
              @change="changeend"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col style="height: 36px">
          <el-form-item label="收费开始日期" prop="startChargeDate">
            <el-date-picker
              v-model="form.startChargeDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled || isReRent"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col style="height: 36px">
          <el-form-item label="收费截止日期" prop="endChargeDate">
            <el-date-picker
              v-model="form.endChargeDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="title == '退租'"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            title != '业主登记' &&
            title != '续租' &&
            title != '租赁' &&
            title != '退租' &&
            title != '车位关联'
          "
          style="height: 36px"
        >
          <el-form-item label="过户日期" prop="endChargeDate">
            <el-date-picker
              v-model="form.transferDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col style="height: 36px" hidden>
          <el-form-item label="历史租赁结束日期" prop="oldEndLeaseDate">
            <el-date-picker
              v-model="form.oldEndLeaseDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :disabled="isEditDisabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-back" @click="handleCancel">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-document"
          @click="handleConfirm"
          >确 定</el-button>
      </span>
    </el-dialog>
    <proCostnormRef
      :multiple="true"
      ref="proCostnormRef"
      :title="houseCustDefendTitle"
      :visible="houseCostnormListVisible"
      @cancel="houseCostnormListVisible = false"
      @confirm="handleCostnormlChange"
    />
  </div>
</template>

<script>
import { JsCollapse } from "@/js_components/index.js";
export default {
  name: "houseCustDefendRef",
  components: { JsCollapse },
  data() {
    const checkRequireOnChange = [
      {
        required: true,
        message: " ",
        trigger: "change"
      }
    ];
    return {
      isOwnerStatus: false,
      nameone: "",
      isEditDisabled: false,
      parkingLot: true,
      selection: [],
      houseName: checkRequireOnChange,
      yesOrNoOptions: [
        { label: "是", value: "是" },
        { label: "否", value: "否" }
      ],
      form: {
        populName: undefined,
        populId: undefined,
        houseId: "",
        houseName: undefined,
        linkedHouseId: undefined,
        linkedHouseName: undefined,
        proCostnormId: "",
        proCostnormName: "",
        isHistory: "否",
        isOwner: undefined,
        checkInDate: undefined,
        startChargeDate: undefined,
        endChargeDate: undefined,
        transferDate: undefined,
        startLeaseDate: undefined,
        oldEndLeaseDate: undefined,
        endLeaseDate: undefined,
        signDate: undefined
      },
      rules: {
        populId: [
          {
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        populName: checkRequireOnChange,
        checkInDate: checkRequireOnChange,
        linkedHouseName: checkRequireOnChange,
        isOwner: [],
        proCostnormId: [],
        endLeaseDate: checkRequireOnChange,
        startLeaseDate: checkRequireOnChange
      },
      houseCostnormListVisible: false,
      houseCustDefendTitle: "",
      isproCostnormEditDisabled: false,
      houseCustDefedcustByorgId: true,
      isReRent: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.empty();
        this.isReRent = false;
        this.form.houseId = this.houseId;
        if (this.title != "" && this.title != null) {
          if (this.title == "房产过户") {
            this.nameone = "新业主";
          } else if (this.title == "租赁" || this.title == "续租") {
            this.nameone = "租户姓名";
          } else if (this.title == "车位关联") {
            this.nameone = "房产名称";
          } else {
            this.nameone = "客户名称";
          }
        }
        if (this.title == "房产过户") {
          this.form.isOwner = this.title == "房产过户" ? "是" : undefined;
          this.isOwnerStatus = true;
          this.form.transferDate =
            this.title == "房产过户" ? new Date() : undefined;
          this.form.startChargeDate =
            this.title == "房产过户" ? new Date() : undefined;
        } else {
          this.isOwnerStatus = false;
        }

        //租赁，续租
        if (this.title == "租赁" || this.title == "续租") {
          this.form.isHistory =
            this.title == "租赁" || this.title == "续租" ? "否" : undefined;
          this.form.isOwner =
            this.title == "租赁" || this.title == "续租" ? "否" : undefined;
          this.isOwnerStatus = true;
          this.rules.isOwner = [];
        } else {
          let isOwner = {
            required: true,
            message: " ",
            trigger: "change"
          };
          this.rules.isOwner.push(isOwner);
        }
        if (
          (this.workType === "reRent" && this.endrentPopulId != undefined) ||
          (this.workType === "endRent" && this.endrentPopulId != undefined)
        ) {
          this.$http
            .post(this.api.ProHouseregisQueryByCondition, {
              condition: {
                houseId: this.houseId,
                populId: this.endrentPopulId,
                isNotHistory: true
              },
              number: 1,
              size: 1
            })
            .then(res => {
              if (res.data && res.data.code === "200") {
                if (res.data.body.total == 1 && !res.data.body.records[0]) {
                } else {
                  this.form = res.data.body.records[0];
                  if (this.workType === "endRent") {
                    this.form.endRentTime = new Date();
                  }
                  this.isReRent = true;
                  if (
                    this.form.startLeaseDate == undefined &&
                    this.title == "续租"
                  ) {
                    this.handleCancel();
                    this.$message({
                      message: "该客户不为租户，不能续租", //
                      type: "warning"
                    });
                  }
                  if (
                    this.form.endLeaseDate != undefined &&
                    this.title == "续租"
                  ) {
                    this.form.oldEndLeaseDate = this.form.endLeaseDate;
                    var oldLeaseDate = new Date(this.form.endLeaseDate);
                    if (
                      oldLeaseDate != undefined &&
                      oldLeaseDate < new Date()
                    ) {
                      this.handleCancel();
                      this.$message({
                        message:
                          "只能对租赁结束日期大于等于当前日期的租户进行续租",
                        type: "warning"
                      });
                    }
                  }
                }
              }
            });
        }
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "80%"
    },
    houseId: {
      type: String,
      default: () => undefined
    },
    endrentPopulId: {
      type: String,
      default: () => undefined
    },
    workType: {
      type: String,
      default: () => undefined
    },
    title: {
      type: String,
      default: () => "房产客户信息"
    },
    populids: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    rulesNo() {
      var tit = this.title;
      if (tit == "租赁" || tit == "续租") {
        this.isOwnerStatus = true;
        let startLeaseDate = {
          required: true,
          message: " ",
          trigger: "change"
        };
        this.rules.startLeaseDate.push(startLeaseDate);
        if (tit == "租赁" || tit == "续租") {
          let endLeaseDate = {
            required: true,
            message: " ",
            trigger: "change"
          };
          this.rules.endLeaseDate.push(endLeaseDate);
        }
      }
    },
    changestart() {
      if (
        this.title == "租赁" ||
        this.title == "续租" ||
        this.title == "车位关联"
      ) {
        this.form.startChargeDate = this.form.startLeaseDate;
      }
    },
    changeend() {
      if (
        this.title == "租赁" ||
        this.title == "续租" ||
        this.title == "车位关联"
      ) {
        this.form.endChargeDate = this.form.endLeaseDate;
      }
    },
    checkdate(value) {
      if (this.title == "业主登记") {
        this.form.startChargeDate = value;
      }
    },
    empty() {
      this.form = {
        populName: undefined,
        populId: undefined,
        houseId: undefined,
        linkedHouseId: undefined,
        linkedHouseName: undefined,
        houseName: undefined,
        proCostnormId: "",
        proCostnormName: "",
        isHistory: "否",
        isOwner: undefined,
        checkInDate: undefined,
        startChargeDate: undefined,
        endChargeDate: undefined,
        transferDate: undefined,
        startLeaseDate: undefined,
        oldEndLeaseDate: undefined,
        endLeaseDate: undefined,
        signDate: undefined,
        endRentTime: undefined
      };
    },
    isChargeObjChange(obj) {
      if (obj === "是") {
        this.form.proCostnormId = "";
        this.form.proCostnormName = "";
        let proCostnormId = {
          required: true,
          message: " ",
          trigger: "change"
        };
        this.rules.proCostnormId.push(proCostnormId);
      } else {
        this.form.proCostnormId = "";
        this.form.proCostnormName = "";
        this.rules.proCostnormId = [];
      }
    },
    changeproCostnormId(val) {
      if (val == null || val === "") {
        this.form.proCostnormId = "";
      }
    },
    partiesClick() {
      if (this.isproCostnormEditDisabled == true) {
        return;
      }
      this.houseCostnormListVisible = true;
      this.houseCustDefendTitle = "选择收费标准";
    },
    handleCostnormlChange(val) {
      //多条数据操作
      for (let key in val) {
        this.form.proCostnormId = this.form.proCostnormId + val[key].id + ",";
        if (this.form.proCostnormName == "") {
          this.form.proCostnormName = this.form.proCostnormName + val[key].name;
        } else {
          this.form.proCostnormName =
            this.form.proCostnormName + "," + val[key].name;
        }
      }
      // }
      this.houseCostnormListVisible = false;
    },
    async validate() {
      const validatorList = [this.$refs["form"].validate];
      let valid;
      for (let i = 0; i < validatorList.length; i++) {
        if (typeof validatorList[i] === "function") {
          valid = await validatorList[i]();
        }
        if (!valid) {
          break;
        }
      }
      //业主登记
      if (this.workType == "populRegis") {
        if (!this.form.checkInDate) {
          this.$message({
            message: "请选择入住日期！", //
            type: "warning"
          });
          valid = false;
        }
      } else if (this.workType == "transfer") {
        //房产过户
        if (!this.form.transferDate) {
          this.$message({
            message: "请选择过户日期！", //
            type: "warning"
          });
          valid = false;
        }
      } else if (this.workType == "rent") {
        //租赁
        ///if (!this.form.startLeaseDate) {
        //this.$message({
        //  /message: "请选择租赁开始日期！", //
        //  type: "warning"
        // });
        // valid = false;
        // }
      } else if (this.workType == "endRent") {
        //退租
        //if (!this.form.endLeaseDate) {
        // this.$message({
        //  message: "请选择租赁结束日期！", //
        // type: "warning"
        //});
        // valid = false;
        //}
      } else if (this.workType == "reRent" || this.workType == "parkingLot") {
        //续租
        if (
          this.form.oldEndLeaseDate != undefined &&
          this.form.endLeaseDate >= this.form.oldEndLeaseDate &&
          this.form.endLeaseDate <= this.form.startLeaseDate
        ) {
          this.$message({
            message: "续租结束日期不能小于等于历史租赁结束日期！", //
            type: "warning"
          });
          valid = false;
        }
        if (this.form.endLeaseDate <= this.form.startLeaseDate) {
          this.$message({
            message: "续租结束日期不能小于等于租赁开始日期！", //
            type: "warning"
          });
          valid = false;
        }
        if (
          this.form.oldEndLeaseDate != undefined &&
          this.form.endLeaseDate <= this.form.oldEndLeaseDate
        ) {
          this.$message({
            message: "续租结束日期不能小于等于历史租赁结束日期！", //
            type: "warning"
          });
          valid = false;
        }
      }
      return valid;
    },
    handleHouseChange(id, obj) {
      //这里选过来的是表示的房产id数据
      let ids;
      ids = this.form.linkedHouseId;
      this.form.linkedHouseId = id;
      this.form.linkedHouseName = obj.name;
      //校验重复添加客户
      if (ids != undefined) {
        if (ids === id) {
          this.form.linkedHouseId = "";
          this.form.linkedHouseName = "";
          this.$message({
            message: "请勿添加重复房产！",
            type: "warning"
          });
        }
      }
    },
    handlePopulChange(id, obj) {
      this.form.populId = id;
      this.form.populName = obj.name;
      if (this.title != "房产过户") {
        //校验重复添加客户
        this.populids.forEach(popuId => {
          if (popuId === id) {
            this.form.populId = "";
            this.form.populName = "";
            this.$message({
              message: "请勿添加重复客户！",
              type: "warning"
            });
          }
        });
      }
    },
    handleCancel() {
      this.endrentPopulId = undefined;
      this.isReRent = false;
      this.empty();
      this.$emit("cancel");
      this.$refs["form"].resetFields();
      this.form.proCostnormId = "";
    },
    handleConfirm() {
      this.validate().then(valid => {
        if (!valid) {
          return false;
        }
        if (this.title == "租赁" || this.title == "续租") {
          if (
            this.form.startLeaseDate == "" ||
            this.form.startLeaseDate == undefined ||
            this.form.endLeaseDate == "" ||
            this.form.endLeaseDate == undefined
          ) {
            if (
              this.form.startLeaseDate == "" ||
              this.form.startLeaseDate == undefined
            ) {
              if (
                this.form.endLeaseDate == "" ||
                this.form.endLeaseDate == undefined
              ) {
                this.$message({
                  message:
                    "请选择" +
                    this.title +
                    "开始日期和" +
                    this.title +
                    "结束日期！", //
                  type: "warning"
                });
                return;
              } else {
                this.$message({
                  message: "请选择" + this.title + "开始日期！", //
                  type: "warning"
                });
                return;
              }
            } else {
              if (
                this.form.endLeaseDate == "" ||
                this.form.endLeaseDate == undefined
              ) {
                this.$message({
                  message: "请选择" + this.title + "结束日期！", //
                  type: "warning"
                });
                return;
              }
            }
          }
          if (this.form.isChargeObj == "是" && this.title == "租赁") {
            if (
              this.form.proCostnormName == "" ||
              this.form.proCostnormName == undefined
            ) {
              this.$message({
                message: "收费对象的收费标准必填！", //
                type: "warning"
              });
              return;
            }
          }
        }

        if (this.title == "退租") {
          this.form.isHistory = "是";
        }

        this.form.houseId = this.houseId; //注入房源主键
        this.form.workflowType = this.workType; //注入业务操作类型
        this.$http
          .post(this.api.ProHouseregisSaveByWorkflowType, this.form)
          .then(res => {
            if (res.data.code == "200") {
              this.editState = false;
              this.$emit("confirm", this.form.houseId ? this.selection : "");
              this.endrentPopulId = undefined;
              this.isReRent = false;
              this.empty();
              this.$refs["form"].resetFields();
              this.form.proCostnormId = "";
            } else {
              this.$message.error(res.data.body);
            }
          });
      });
    },
    search() {
      this.pageData.pageNumber = 1;
      return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    }
  },
  mounted() {
    let sysDic = JSON.parse(localStorage.getItem("sysDic") || "{}");
  }
};
</script>

<style scoped lang="less">
// .com-populregister-ref {}
/deep/ .dialog-no-header > .el-dialog__header {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/houseRegis/houseCustDefendRef.vue